import React, {FC} from 'react';
import {Icon} from './Icon';
import {UserAddress} from "../types/types";
import { nToast } from '../plugins/reactToast';
import {api} from "../plugins/axios";
import { removeAddress } from '../apis/user';

interface AddressPopUpProps {
    open: boolean;
    onClose: () => void;
    addresses: UserAddress[];
    onSelected: (address: UserAddress) => void;
}

export const AddressPopUp: FC<AddressPopUpProps> = (props) => {
    const {onClose, open, addresses = [], onSelected} = props;

    if (!open) return <></>;

    const handleRemoveAddress = (addressId: number) => {
        removeAddress(addressId).then(r => {
            if (r.data.code === 'SUCCESS') {
                nToast('주소가 삭제 되었습니다.');
            }
        }).catch((e) => {
            if (e.response?.data.message) {
                nToast(e.response.data.message);
            } else {
                nToast('주소 삭제에 실패 하였습니다.');
            }
        });
    }

    return (
        <>
            <div className="z-50 fixed inset-0 bg-littleblack flex items-center justify-center px-4 ">
                <div className=" w-96 flex flex-col  bg-white p-6 space-y-4 overflow-y-auto">
                    <div className="flex flex-row justify-between ">
                        <p className="text-18 font-medium">배송지 선택</p>
                        <button
                            onClick={onClose}
                            className="flex flex-row space-x-2 items-center"
                        >
                            <Icon.X/>
                        </button>
                    </div>

                    {addresses.map((item, index) => (
                        <div className="flex flex-row justify-between" key={item.addressId}>
                            <button key={index} className="text-left border-b pb-4" onClick={() => onSelected(item)}>
                                <div className="flex space-x-2">
                                    <p className="font-semibold">{item.addressName}</p>
                                    {item.isDefault && (
                                        <p className="font-semibold text-blue-600">(기본)</p>
                                    )}
                                </div>
                                <p className="text-15 text-gray-500">{item.sido} {item.gugun} {item.address}</p>
                            </button>
                            <div className="flex flex-row space-x-2 items-center">
                                <button onClick={ ()=> handleRemoveAddress(item.addressId)}><Icon.X className="wh-3" /></button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
